export default __webpack_public_path__ + "static/banner-finance-a-better-family-car-20e719f9337a6fd3c4c60c81a2022a01.jpg";